import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
 import {BrowserRouter/*, Route, Routes*/ } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <React.StrictMode>
  
    <App />
   
  </React.StrictMode>
  </BrowserRouter>
);
// ReactDOM.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={ <App /> }>
//         </Route>
//       </Routes>
//     </BrowserRouter>
//   </React.StrictMode>,
//   document.getElementById('root')
// );
